<!-- apps/web/src/components/icons/IconReports.vue -->
<template>
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
       stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
    <path d="M3 3v18h18"/>
    <path d="M7 14l4-4 4 4 5-5"/>
  </svg>
</template>
